<template>
  <div class="user-info">
    <div class="user-details">

      <div class="user-avatar">
        <a-avatar :src="user.avatar" :size="64" v-if="user.avatar"></a-avatar>
        <a-avatar  :size="64" v-else>{{user.name}}</a-avatar>
      </div>
      <div class="user-name">{{ user.name }}</div>
      <div class="user-role">{{ user.role }}</div>
      <div class="user-email">{{ user.email }}</div>
      <div class="user-phone">{{ user.phone || '未填写手机号' }}</div>
      <div class="user-department">{{ user.department || '未填写部门' }}</div>
      <div class="user-registered">注册时间：{{ user.registeredAt || '未知' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeUserInfo',
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.user-info {
  background: var(--color-bg-3);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  padding: 32px 28px 28px 28px;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
}
.user-avatar {
  align-items: center;
  justify-content: center;
}
.user-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.user-name {
  font-size: 22px;
  font-weight: bold;
  color: var(--color-text-2);
  margin-bottom: 2px;
}
.user-role {
  font-size: 14px;
  color: #4a90e2;
  font-weight: 500;
  margin-bottom: 4px;
}
.user-email {
  font-size: 13px;
  color: var(--color-text-2);
  margin-top: 2px;
}
.user-phone {
  font-size: 13px;
  color: var(--color-text-2);
  margin-top: 2px;
}
.user-department {
  font-size: 13px;
  color: var(--color-text-2);
  margin-top: 2px;
}
.user-registered {
  font-size: 12px;
  color: var(--color-text-1);
  margin-top: 2px;
}
</style>